import {Component, OnInit} from "@angular/core";
import {PreguntaModelDTO} from "@Models";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";


@Component({
    selector: "app-tipo-pregunta-url",
    templateUrl: "./tipo-pregunta-url.component.html",
    styleUrls: ["./tipo-pregunta-url.component.scss"]
})
export class TipoPreguntaUrlComponent extends TipoPreguntaComponent implements OnInit {
    public pregunta: PreguntaModelDTO;

    constructor(private tiposPreguntasService: TiposPreguntasService) {
        super();
    }

    public ngOnInit(): void {
        this.pregunta = this.tiposPreguntasService.preguntaModel;
    }

}
